var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ca-form", attrs: { id: "vendor-data" } },
    [
      _vm.vendor
        ? _c("el-form", [
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Name" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.vendor.firstName) +
                        " " +
                        _vm._s(_vm.vendor.lastName) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Email" } },
                  [_vm._v(" " + _vm._s(_vm.vendor.email || "-") + " ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Phone" } },
                  [_vm._v(" " + _vm._s(_vm.vendor.phone || "-") + " ")]
                ),
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Phone 2" } },
                  [_vm._v(" " + _vm._s(_vm.vendor.phone2 || "-") + " ")]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Distance" } },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          this.distance
                            ? this.distance.toFixed(2)
                            : this.distance
                        ) +
                        " miles. "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.hideFee
              ? _c(
                  "div",
                  { staticClass: "ca-single-line" },
                  [
                    _c(
                      "el-form-item",
                      { staticClass: "w50", attrs: { label: "Vendor Type" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.order.personAtPropertyType || "-") +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "el-form-item",
                      { staticClass: "w50", attrs: { label: "License Type" } },
                      [
                        _vm.order.pdcLicenseType !== null
                          ? _c(
                              "span",
                              { staticStyle: { display: "inline-block" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.order.pdcLicenseType) +
                                    " - " +
                                    _vm._s(_vm.order.pdcLicenseState) +
                                    " "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("No License Information")]),
                      ]
                    ),
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "ca-single-line" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Vendor Fee" } },
                      [
                        _c("el-input", {
                          attrs: { maxlength: "50", placeholder: "Vendor Fee" },
                          model: {
                            value: _vm.order.vendorFee,
                            callback: function ($$v) {
                              _vm.$set(_vm.order, "vendorFee", $$v)
                            },
                            expression: "order.vendorFee",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
            _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  { staticClass: "w50", attrs: { label: "Address" } },
                  [
                    _c("span", { staticStyle: { display: "inline-block" } }, [
                      _vm._v(_vm._s(_vm.vendor.address) + ","),
                      _c("br"),
                      _vm._v(
                        " " +
                          _vm._s(_vm.vendor.city) +
                          ", " +
                          _vm._s(_vm.vendor.state) +
                          " " +
                          _vm._s(_vm.vendor.postalCode) +
                          " "
                      ),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }